<template>
  <div class="app-container">
    <headTitle title="注册结果"></headTitle>
    <div class="body">
      <img src="@/assets/images/icon-change-phone-success.png" alt="" />
      <span>注册成功</span>
    </div>
  </div>
</template>

<script>
import headTitle from '@/components/headTitle/index.vue';

export default {
  name: '',
  components: { headTitle },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.app-container {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  .body {
    flex: 1;
    padding-top: 62px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    img {
      width: 90px;
      height: 90px;
    }
    span {
      margin-top: 32px;
      color: #333333;
      font-size: 18px;
      font-weight: 400;
    }
  }
}
</style>
